import { render, staticRenderFns } from "./laws_index.vue?vue&type=template&id=37b8af51&scoped=true"
import script from "./laws_index.vue?vue&type=script&lang=js"
export * from "./laws_index.vue?vue&type=script&lang=js"
import style0 from "./laws_index.vue?vue&type=style&index=0&id=37b8af51&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b8af51",
  null
  
)

export default component.exports